
import { defineComponent } from "vue";
import { store } from "@/store";
import { destroy as removeApi } from "@smace-technologies/workspace/src/permission";

export default defineComponent({
  components: {},
  props: {
    userEmail: {
      required: true,
    },
  },
  emits: ["reload"],
  data() {
    return {
      submitted: false,
      loading: false,
      email: "",
    };
  },
  computed: {
    workspaceId: function () {
      return store.getters["getBaseWorkspaceId"];
    },
  },
  watch: {},
  mounted() {
    this.email = "";
  },
  methods: {
    submit: async function () {
      this.submitted = true;
      await removeApi(
        store.getters["getBaseWorkspaceId"],
        this.email,
        store.getters["getJWT"]
      );
      this.submitted = false;

      const el = this.$refs["closeBtn"] as any;
      el.click();
      this.$emit("reload");
    },
  },
});
